import { reactive, readonly } from 'vue'

// ! activeComponent options:
// ? 'table', 'view', 'edit', 'create'
// ? special case component: Lead 

const masterState = reactive({
    activeComponent: "table",
    data: null,
    deleteId: null,
    editId: null,
    viewId: null,
    editBool: false,
})

const methods = {
    changeComponent: async (name) => {
        if (!name) return;
        masterState.activeComponent = name;
    },
    changeData: async (data) => {
        if (typeof data !== "object") return
        masterState.data = data;
        return;
    },
    setId: async (field, id) => {
        if (!field) return;
        if (field === 'delete') masterState.deleteId = id;
        if (field === 'edit') masterState.editId = id;
        return;
    },
    setEditBool: async (boolean) => {
        masterState.editBool = boolean;
    },

    destroy: async () => {
        masterState.activeComponent = "table";
        masterState.data = null;
        masterState.deleteId = null;
        masterState.editId = null;
        masterState.editBool = false;
    }
}

export default {
    state: masterState,
    methods,
}